import React from 'react';
import ContentWidget from '../../../../components/ContentWidget';
import iconDirector from '../../../../assets/icons/icon-director.png';
import Button from '../../../../components/Button';

const RecommendedCourses = () => {
  const courses = [
    {
      title: 'Beginner Communication',
      description: 'In this course you will learn about something cool',
      icon: iconDirector
    },
    {
      title: 'Active Listening',
      description: 'In this course you will learn about something cool',
      icon: iconDirector
    },
    {
      title: 'Positive Questioning',
      description: 'In this course you will learn about something cool',
      icon: iconDirector
    }
  ];

  return (
    <ContentWidget
      title="Your Course Recommendations"
      subtitle="Handpicked courses based on your archetype."
      height={400}
      margin={false}
      rounded={false}>
      <div className="flex flex-col justify-center items-center pt-4 mt-2 overflow-hidden items-center">
        {courses.map((course, index) => (
          <div
            className="flex my-1 hover:bg-gray-200 min-w-full p-4 rounded"
            key={index}>
            <img src={course.icon} className="h-14 w-14 mr-4" alt="" />
            <div className="flex flex-col">
              <span className="">{course.title}</span>
              <span className="text-xs text-gray-400">
                {course.description}
              </span>
            </div>
          </div>
        ))}
        <Button path="/courses" outline text="VIEW ALL COURSES" />
      </div>
    </ContentWidget>
  );
};

export default RecommendedCourses;
